import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{directives:[{def: Ripple,name:"ripple",rawName:"v-ripple"}],staticClass:"home-tile",attrs:{"flat":""}},[_c('div',{staticClass:"d-flex align-center"},[_c(VIcon,{staticClass:"home-tile__icon"},[_vm._v(_vm._s(_vm.icon))]),_c('div',{staticClass:"v-card-h2"},[_vm._v(_vm._s(_vm.title))])],1),_c('div',{staticClass:"v-card-h4 home-tile__description"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }